import { upperFirst } from 'lodash-es';

export const sentenceCase = (str: string) => {
  return upperFirst(str.toLowerCase());
};
